<div class="container">

  <h4 class="form-page-name">
      Contractor Resources
  </h4>

  <div class="retrofit-form-text">
    <div [innerHTML]="textContractorResources"></div>
  </div>


  <div style="min-height: 50px;"></div>

</div>
